<i18n>
{
  "ja": {
    "keywords": "倉庫を貸したい,ウェアエックス,WareX",
    "title": "倉庫スペースを提供したい方へ",
    "description": "使っていない倉庫スペースをそのままにしていませんか？Warexに登録すれば、遊休スペースを活用して新たな収入源にすることが可能です。"
  }
}
</i18n>
    
<template>
  <div>
    <fortheowners :case-studies="caseStudies" :white-paper="whitePaper" :seminar="seminar"></fortheowners>
    <BreadcrumbsFoot :list="breadcrumbs" />
  </div>
</template>

<script>
import Fortheowners from "@/components/fortheowners/fortheowners"
import BreadcrumbsFoot from "@/components/breadcrumbsFoot";
import Jsonld from '@/components/mixins/jsonld';

export default {
  mixins: [Jsonld],
  components: {
    Fortheowners,
    BreadcrumbsFoot
  },
  data() {
    return {
      breadcrumbs: [
        { name: this.$t('title') }
      ]
    }
  },
  async asyncData({ $strapi, app }) {
    let caseStudies = [], whitePaper = null, seminar = null

    try {
      caseStudies = await $strapi.find("case-studies", [['jobs.name', '倉庫提供者'], ['issues.name', '空きスペースを活用したい']])
      caseStudies = caseStudies.data
      whitePaper = await $strapi.find("white-papers", [['slug', 'provider-paper']])
      whitePaper = whitePaper[0]
      seminar = await $strapi.find("seminars", [['slug', 'wx-seminar-private-warehouse']])
      seminar = seminar[0]
    } catch(e) {
      // Handle error if needed, e.g., log it or show a message
      console.error("Error fetching data:", e);
    }

    return {
      caseStudies,
      whitePaper,
      seminar
    }
  },
  computed: {
    global() {
      return this.$store.getters['cms/global']
    },
    homepage() {
      return this.$store.getters['cms/homepage']
    }
  },
  head() {
    const { seo } = this.homepage;
    const { defaultSeo } = this.global;
    const fullSeo = {
      ...defaultSeo,
      ...seo,
      metaTitle: this.$t('title'),
      metaDescription: this.$t('description'),
      metaKeywords: `${this.$t('keywords')}`
    };
    return {
      title: this.$t('title'),
      meta: this.$options.filters.cmsMetaTags(fullSeo)
    }
  },
  jsonld() {
    const ret = []
    const breadcrumbs = this.getBreadcrumbsJsonld(this.breadcrumbs)
    breadcrumbs && ret.push(breadcrumbs)
    return ret
  }
};
</script>
